import { STORAGE_KEYS } from '@/constants/storage'

export function getToken() {
  return localStorage.getItem(STORAGE_KEYS.TOKEN)
}

export function setToken(token) {
  localStorage.setItem(STORAGE_KEYS.TOKEN, token)
}

export function removeToken() {
  localStorage.removeItem(STORAGE_KEYS.TOKEN)
  localStorage.removeItem(STORAGE_KEYS.REFRESH_TOKEN)
  localStorage.removeItem(STORAGE_KEYS.ROLE)
}

export function setSession({ token, refreshToken, role }) {
  setToken(token)
  if (refreshToken) localStorage.setItem(STORAGE_KEYS.REFRESH_TOKEN, refreshToken)
  if (role) localStorage.setItem(STORAGE_KEYS.ROLE, role)
}
